const state = () => {
  return {
    season: {},
    seasons: [],
  }
}

export default state;
